import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "w-full rounded-2xl bg-white flex flex-row items-center border"
}
const _hoisted_3 = { class: "flex items-center justify-center relative" }
const _hoisted_4 = {
  class: "text-center absolute font-bold",
  style: {"font-size":"9.5px"}
}
const _hoisted_5 = { class: "text-xl font-bold flex" }
const _hoisted_6 = { class: "text-red-lp-100 px-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_DonutChart = _resolveComponent("DonutChart")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_Skeleton, {
          class: "w-full rounded-2xl",
          height: "2rem"
        })
      ]))
    : (_openBlock(), _createBlock("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_DonutChart, {
            chartSeries: _ctx.chartData,
            chartColor: _ctx.chartColor,
            chartHeight: "80",
            size: "70%",
            showPercentage: true,
            chartWidth: "70px"
          }, null, 8, ["chartSeries", "chartColor"]),
          _createVNode("div", _hoisted_4, _toDisplayString(_ctx.progress) + "% ", 1)
        ]),
        _createVNode("span", _hoisted_5, [
          _createTextVNode(_toDisplayString(_ctx.$t('dashboard.cardProgress.complete')) + " ", 1),
          _createVNode("p", _hoisted_6, _toDisplayString(_ctx.totalPending || 0), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('dashboard.cardProgress.activitiesToday')), 1)
        ])
      ]))
}